import binSearch from 'binary-search';
import moment from 'moment';

class LocationBlock {
  constructor(options) {
    this.startAt = moment(options.startAt);
    this.endAt = moment(options.endAt);
    this.device = options.device;
    this.positions = options.positions;
    this.events = options.events;
    this._normalizePositions();
    this._normalizeEvents();
    this._sortPositions();
  }

  _comparator = (e, n) => e.position_at - n;

  locationAtOrBefore(t) {
    if (t > this.endAt) {
      return null;
    }

    let ix = binSearch(this.positions, t, this._comparator);

    if (ix === -1) {
      // No match and t is less than the smallest position in this block
      return this.device.lastPriorPosition;
    }

    if (ix < -1) {
      // No exact match but we have something close
      ix = (ix * -1) - 2;
    }

    if (ix < this.positions.length) {
      return this.positions[ix];
    }

    return null;
  }

  /**
   * Returns true if the given time t exists between start and end
   * of this block.
   */
  includesTime(t) {
    // Range check is INCLUSIVE
    return moment(t).isBetween(this.startAt, this.endAt, undefined, '[]');
  }

  /**
   * Returns true if the given period fully exists between start and end
   * of this block.
   */
  includesDuration(startAt, endAt) {
    // Range checks are INCLUSIVE
    const startInRange = moment(startAt).isBetween(this.startAt, this.endAt, undefined, '[]');
    const endInRange = moment(endAt).isBetween(this.startAt, this.endAt, undefined, '[]');

    return startInRange && endInRange;
  }

  /**
   * Merge one location block into another.
   */
  merge(block) {
    this.startAt = moment(Math.min(this.startAt, block.startAt));
    this.endAt = moment(Math.max(this.endAt, block.endAt));
    this.positions = this.positions.concat(block.positions);
    this._sortPositions();
  }

  _normalizePositions() {
    this.positions.forEach((pos) => {
      pos.position_at = moment(pos.position_at || pos.created_at);
    });
  }

  _normalizeEvents() {
    this.events.forEach((event) => {
      event.event_at = moment(event.event_at);
    });
  }

  _sortPositions() {
    this.positions.sort((a, b) => a.position_at - b.position_at);
  }

  _sortEvents() {
    this.events.sort((a, b) => a.event_at - b.event_at);
  }
}

export default LocationBlock;
